import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=def2ec1c&scoped=true"
import script from "./SiteLayout.vue?vue&type=script&lang=js"
export * from "./SiteLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def2ec1c",
  null
  
)

export default component.exports